import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';

const PreviousCost = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [costs, setCosts] = useState([]);

  const [editData, setEditData] = useState({
    id: null,
    title: '',
    media: '',
    description: ''
  });

  const [formData, setFormData] = useState({
    title: '',
    media: '',
    description: ''
  });

  const fetchCosts = async () => {
    try {
      const res = await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/pcost');
      console.log(res.data);
      setCosts(res.data);
    } catch (e) {
      setError(e.response?.data?.message || 'Fetch failed');
    }
  };

  useEffect(() => {
    fetchCosts();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenModal = () => {
    setFormData({ title: '', media: '', description: '' });
    setShowModal(true);
    setError('');
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
    try {
      const data = new FormData();
      data.append('title', formData.title);
      data.append('media', formData.media);
      data.append('description', formData.description);
      await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/pcost', data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      setShowModal(false);
      setFormData({ title: '', media: '', description: '' });
      fetchCosts();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setEditData({
      id: item.id,
      title: item.title,
      media: item.image,
      description: item.description
    });
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/pcost/${id}`);
      fetchCosts();
    } catch (e) {
      setError(e.response?.data?.message || 'Delete failed');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setError('');
    try {
      const data = new FormData();
      data.append('title', editData.title);
      data.append('media', editData.media);
      data.append('description', editData.description);
      await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/pcost/${editData.id}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      fetchCosts();
      setShowEditModal(false);
    } catch (e) {
      setError(e.response?.data?.message || 'Update failed');
      setShowEditModal(false);
    } finally {
      setLoading(false);
    }
  };

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };

  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Previous Costs</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>S.No.</th>
                <th>Project Name</th>
                <th>Image</th>
                <th>Location</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {costs.length > 0 ? (
                costs.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td><img src={uploadUrl(item.image)} alt="Previous cost" width="100"/></td>
                    <td>{item.description}</td>
                    <td className="text-center">
                      <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => handleEdit(item)}>Edit</button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No Previous Costs Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Previous Cost</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Project Name"
                  value={formData.title} 
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                />
                <textarea
                  className="form-control mb-2"
                  rows="4"
                  placeholder="Cost Details (e.g., Total: ₹X, Breakdown: ...)"
                  value={formData.description} 
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Previous Cost</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowEditModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Project Name"
                  value={editData.title} 
                  onChange={(e) => setEditData({ ...editData, title: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  onChange={(e) => setEditData({ ...editData, media: e.target.files[0] })}
                />
                <textarea 
                  className="form-control mb-2"
                  rows="4"
                  placeholder="Cost Details"
                  value={editData.description} 
                  onChange={(e) => setEditData({ ...editData, description: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleUpdate} disabled={loading}>
                  {loading ? 'Updating...' : 'Update'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviousCost;
